/**
 * Created by slava on 7/17/17.
 */

// Time from the page start (performance.now) to afterResourceLoaded, in seconds; 60 when loading did not finish in a minute.
const LogTimeStart = function () {
    this.timeout = setTimeout(this.stop.bind(this), 60000);
};

LogTimeStart.prototype.stop = function () {
    if (this.timeout === undefined) {
        return;
    }

    clearTimeout(this.timeout);
    this.timeout = undefined;

    if (!cleverapps.user || !cleverapps.metrics || typeof performance === "undefined" || !performance.now) {
        return;
    }

    const newbie = cleverapps.user.registered + cleverapps.parseInterval("1 day") > Date.now();

    cleverapps.metrics.logEvent(newbie ? cleverapps.EVENTS.STATS.TIMESTART_NEW : cleverapps.EVENTS.STATS.TIMESTART_OLD, {
        value: Math.min(performance.now() / 1000, 60)
    });
};

LogTimeStart.active = new LogTimeStart();
